import { ValidatorFn, AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export function conditionalRequiredValidator(conditionalKey: string, requiredValues: any[], targetKeys: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const group = control as FormGroup;
        const conditional = group.get(conditionalKey);
        if (!conditional) {
            return null;
        }

        const isControllingValueMatched = requiredValues.some(requiredValue => {
            return conditional.value === requiredValue;
        });

        let hasError = false;

        if (isControllingValueMatched) {
            hasError = targetKeys.some(targetKey => {
                const target = group.get(targetKey);
                if (target && (target.value == null || target.value === '')) {
                    return true;
                } else {
                    return false
                }
            });
        }

        return hasError ? { conditionalRequired: true } : null;
    };
}